// extracted by mini-css-extract-plugin
module.exports = {"container":"WYVhY","value":"_3OzXm"};